import { render, staticRenderFns } from "./ModalCadastroDisciplinaPreRequisito.vue?vue&type=template&id=7b2fc6a2"
import script from "./ModalCadastroDisciplinaPreRequisito.vue?vue&type=script&lang=js"
export * from "./ModalCadastroDisciplinaPreRequisito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports